import { WizardSession, WizardSessionsSnapshot } from "./types";

/**
 * Combines two copies of the sessions (this tab's and another tab's) one
 * session at a time. The most recently updated copy wins, and a session
 * discarded after its last update stays discarded. Ties keep `local`'s copy,
 * so merging an unchanged copy returns `local`'s session objects.
 */
export function mergeSessions(
  local: WizardSessionsSnapshot,
  incoming: WizardSessionsSnapshot,
): WizardSessionsSnapshot {
  const discarded: Record<string, number> = {};
  const discardedIds = new Set([
    ...Object.keys(local.discarded),
    ...Object.keys(incoming.discarded),
  ]);
  for (const id of [...discardedIds].sort()) {
    discarded[id] = Math.max(
      local.discarded[id] ?? 0,
      incoming.discarded[id] ?? 0,
    );
  }

  const sessions: Record<string, WizardSession> = {};
  const sessionIds = new Set([
    ...Object.keys(local.sessions),
    ...Object.keys(incoming.sessions),
  ]);
  for (const id of [...sessionIds].sort()) {
    const mine = local.sessions[id];
    const theirs = incoming.sessions[id];
    const winner =
      mine && (!theirs || mine.updatedAt >= theirs.updatedAt) ? mine : theirs;
    const discardedAt = discarded[id];
    if (discardedAt !== undefined && discardedAt >= winner.updatedAt) {
      continue;
    }
    sessions[id] = winner;
  }

  return { sessions, discarded };
}
